import { useState } from 'react';
import {
  Typography, TextField, Button, Table, TableBody, TableCell,
  TableHead, TableRow, Box, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import axios from 'axios';

const API = 'https://attend.zventures.in';

const VehicleManagement = ({ vehicles, setVehicles, locations }) => {
  const [form, setForm] = useState({ name: '', capacity: '', plate: '', owner: '', location: '' });

  const addVehicle = async () => {
    if (!form.name || !form.location) return;
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/api/vehicles`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVehicles(prev => [...prev, res.data]);
      setForm({ name: '', capacity: '', plate: '', owner: '', location: '' });
    } catch (err) {
      console.error('Error adding vehicle:', err);
    }
  };

  const removeVehicle = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/api/vehicles/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVehicles(prev => prev.filter(v => v._id !== id));
    } catch (err) {
      console.error('Error removing vehicle:', err);
    }
  };

  const locationNames = (locations || []).map(l => l.name);
  const colStyle = { minWidth: 120 };

  return (
    <Box sx={{ background: 'linear-gradient(to bottom right,#e6f0f9,#e6f0f9)', borderRadius: '10px', p: 3, mb: '5%' }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 400 }}>Admin Panel – Manage Vehicles</Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
        <TextField label="Vehicle Name"  value={form.name}
          onChange={e => setForm({ ...form, name: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 150 }} />
        <TextField label="Capacity" type="number" value={form.capacity}
          onChange={e => setForm({ ...form, capacity: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 110 }} />
        <TextField label="Number Plate" value={form.plate}
          onChange={e => setForm({ ...form, plate: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 150 }} />
        <TextField label="Owner" value={form.owner}
          onChange={e => setForm({ ...form, owner: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 150 }} />
        <FormControl sx={{ minWidth: 160, backgroundColor: 'white' }}>
          <InputLabel>Location</InputLabel>
          <Select value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} label="Location">
            {locationNames.map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
          </Select>
        </FormControl>
        <Button variant="contained" onClick={addVehicle}>Add Vehicle</Button>
      </Box>

      <Box sx={{ borderRadius: 2, backgroundColor: '#ffffffcc', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 300, color: '#1e3a8a' }}>Vehicle List</Typography>
        <Table>
          <TableHead>
            <TableRow sx={{ background: '#f0f4ff' }}>
              <TableCell style={colStyle}><strong>Name</strong></TableCell>
              <TableCell style={colStyle}><strong>Capacity</strong></TableCell>
              <TableCell style={colStyle}><strong>Number Plate</strong></TableCell>
              <TableCell style={colStyle}><strong>Owner</strong></TableCell>
              <TableCell style={colStyle}><strong>Location</strong></TableCell>
              <TableCell><strong>Action</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vehicles.length === 0 ? (
              <TableRow><TableCell colSpan={6} align="center">No vehicles added yet</TableCell></TableRow>
            ) : vehicles.map(v => (
              <TableRow key={v._id || v.plate}>
                <TableCell>{v.name}</TableCell>
                <TableCell>{v.capacity}</TableCell>
                <TableCell>{v.plate}</TableCell>
                <TableCell>{v.owner}</TableCell>
                <TableCell>{v.location}</TableCell>
                <TableCell>
                  <Button color="error" variant="outlined" size="small" onClick={() => removeVehicle(v._id)}>
                    Remove
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default VehicleManagement;